import React from 'react';
import clsx from 'clsx';
import { Container } from 'semantic-ui-react';
import MarkdownRender from '../text-editors/MarkdownRender';

const MarkdownContainer = ({
  className,
  value,
  fluid,
}) => (
  <Container className={clsx('aridhia-markdown-container', className)} fluid={fluid}>
    <MarkdownRender value={value} className={className} />
  </Container>
);

export default MarkdownContainer;
